import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../ui/dialog';
import { AlertTriangle } from 'lucide-react'
interface ModalErrorTotalClientesProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  totalClients: number;
  disponivel: number
}

export function ModalErrorTotalClientes({ open, onOpenChange, totalClients, disponivel }: ModalErrorTotalClientesProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='flex items-center flex-col'>
        <AlertTriangle className='text-yellow-icons h-20 w-20' />
        <h2 className='text-lg text-center p-2'>Você selecionou <span className='font-semibold text-red-500'> {totalClients}</span> clientes, mas o orçamento diário da campanha permite o envio para apenas <span className='font-semibold text-green-500'>{disponivel}</span> clientes. Ajuste a seleção para continuar.</h2>

        <Button className='w-full' variant={'destructive'}>Fechar</Button>
      </DialogContent>
    </Dialog>
  )
};
